import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "utils";
import { CXL } from "@/components/Typography";
import Device from "@/utils/device";
import StepForwardTitle from "../step-forward/StepForwardTitle";
import MarketingButton from "../MarketingButton";
import Image from "next/image";

type Summit2024ContentProps = {
  handleClick: (e) => void;
};

const Summit2024Content: FunctionComponent<Summit2024ContentProps> = (
  props
) => {
  return (
    <S.Section data-cy="SF-content-2023">
      <S.GridContainer>
        <S.CopyContainer>
          <StepForwardTitle uppercase>
            Step <br />
            Forward <br />
            <S.FontWeightWrap>2024</S.FontWeightWrap>
          </StepForwardTitle>
          <CXL>
            <S.BoldWrap>
              In 2024, we hosted our Step Forward Summit at Old Sessions House.{" "}
            </S.BoldWrap>
            We brought together an{" "}
            <S.BoldWrap>electrifying line-up of panellists </S.BoldWrap> to
            start a <S.BoldWrap>movement for change.</S.BoldWrap>
          </CXL>
          <CXL>
            Take a look at some of the highlights from our campaign, to give you
            a flavour of what you can expect.{" "}
            <S.BoldWrap>
              This year we’re going even bigger and bolder.
            </S.BoldWrap>
          </CXL>
          <CXL>
            <S.BoldWrap>
              Here’s a taste of what’s in store for 2025....
            </S.BoldWrap>
          </CXL>
          <MarketingButton
            name="access"
            buttonText="Secure your spot"
            colour={colours.charcoal}
            textColour={colours.charcoal}
            animationColour={colours.shell}
            onClick={props.handleClick}
          />
        </S.CopyContainer>
        <S.ImageColumn>
          <S.ImageContainer>
            <Image
              src="/images/step-forward-2025/allbright-square.jpg"
              layout="fill"
              objectFit="cover"
            />
          </S.ImageContainer>
        </S.ImageColumn>
      </S.GridContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 10%;
  background-image: url(/images/step-forward/step-forward-light-gradient.png);
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  gap: 50px;

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }

  @media ${Device.tablet} {
    padding: 5% 10%;
  }
`;

S.GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media ${Device.tablet} {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    gap: 10%;
  }
`;

S.CopyContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.BoldWrap = styled.span`
  font-weight: 700;
`;

S.ImageColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
`;

S.ImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  background: grey;

  @supports not (aspect-ratio: 1) {
    &:before {
      float: left;
      padding-top: 100%;
      content: "";
    }
    &:after {
      display: block;
      content: "";
      clear: both;
    }
  }
`;

export default Summit2024Content;
